module.exports = __webpack_public_path__ + "static/img/flag5.2f8bbc1e.svg";